import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import { Router, ActivationStart, RouterOutlet, ActivatedRoute } from "@angular/router";
import { AddLoginService } from "../login/login.services";
import { AuthLayoutComponent } from "../layouts/auth/auth-layout.component";
import { AuthService } from "../services/auth.service";
import Swal from "sweetalert2";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { LoaderServiceService } from '../services/loaderService.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import { map, Observable,from } from "rxjs";
import { getAuth, getIdTokenResult, signInWithEmailAndPassword } from "firebase/auth";
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
 
  @ViewChild(RouterOutlet) outlet: RouterOutlet;
  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  passwordFormControl = new FormControl("", [Validators.required]);

  matcher = new MyErrorStateMatcher();
  alreadylogged: { "email": any, "username": any, "role": any };
  lastSegment: string;
  private auth2 = getAuth();

  constructor(
    private AuthService: AuthService,
    public router: Router,
    public loginservice: AddLoginService,
    public auth: AuthLayoutComponent,
    private AngularFirestore: AngularFirestore,
    private HttpClient: HttpClient,
    private route: ActivatedRoute,
    private LoaderServiceService: LoaderServiceService,
    private http: HttpClient
  ) { 
  }
 

  ngOnInit() {
    this.AuthService.userChanges();
    // this.captureLastSegment()

  }


  // captureLastSegment() {
  //   this.route.url.subscribe(segments => {
  //     if (segments.length > 0) {
  //       this.lastSegment = segments[0].path;
  //       if (this.lastSegment == "default") {
  //         this.lastSegment = "(default)"
  //       }
  //       console.log('Database Name:', this.lastSegment);
  //     }
  //   });
  //   localStorage.setItem('DbName', this.lastSegment)
  //   this.AngularFirestore.firestore['_databaseId'].database = this.lastSegment

  //   return this.lastSegment;
  // }
  signOut() {
    this.AuthService.logout();
  }
  async resetPassword(): Promise<void> {
    const { value: email } = await Swal.fire({
      title: 'Reset Your Password !',
      text: 'Please enter your email to reset password:',
      input: 'email',
      inputLabel: 'Email',
      inputPlaceholder: 'Enter your email',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      inputValidator: (value) => {
        if (!value) {
          return 'You need to enter your Email!';
        }
      }
    });
    if (email) {
      return this.AuthService.resetPassword(email)
        .then(() => {
          console.log('Password reset email sent');
          Swal.fire({
            icon: "success",
            title: "Password reset email sent. Please check your inbox",
            showConfirmButton: true,
          });
        })
        .catch((error) => {
          console.error('Error sending password reset email', error);
        });
    }

  }
  login() {
    this.auth.active = true;
    let x = this.AuthService.login(
      this.emailFormControl.value,
      this.passwordFormControl.value
    );
    console.log(x);
    this.auth.active = false;
  }
  updateUserservice(email: string, databaseName: string): Observable<any> {
    const url = 'https://createuserwithcustomclaim-tccea3va2a-uc.a.run.app/updateUser';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const body = { email, databaseName };

    return this.http.put<any>(url, body, { headers });
  }
//   TestAddauditS(item){
//     const url = 'https://addauditlasttest-tccea3va2a-uc.a.run.app/addAudit'; // Replace with your function's URL
//                        const   databaseId =  'renaissance'
// console.log(item)

//     const userData = { item ,databaseId};
//     // return this.http.post(url, );
//     return this.http.post(url, userData);
//   }
//   TestAddaudit(){
//     const item = {
//       "module": {
//           "iconios": "ios-american-football",
//           "private": false,
//           "signtureurl": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/4_1711405158892.jpg?alt=media&token=35a1c4c3-a01e-45df-8115-f064b0d14e41",
//           "active": true,
//           "categories": [
//               {
//                   "name": "infrastructure",
//                   "questions": [
//                       {
//                           "id": "94c3163a-c977-4b15-8861-39bd3f25b225",
//                           "answer": true,
//                           "images": [
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405145172.jpg?alt=media&token=594ee5f2-78e6-41b9-adc6-e27e400be8c9"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405146232.jpg?alt=media&token=8ca583e2-3731-4f92-a9fc-4d5d9bd61343"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405147464.jpg?alt=media&token=691c91f0-27dc-4f33-b0fe-5a6165e2622f"
//                               }
//                           ],
//                           "score": 0,
//                           "englishname": "are walls and doors clean and in good condition ",
//                           "answers": [
//                               {
//                                   "arabicchoices": [
//                                       "نظيفة و في حالة جيدة"
//                                   ],
//                                   "score": 5,
//                                   "name": "c",
//                                   "englishchoices": [
//                                       "clean and in good condition"
//                                   ]
//                               },
//                               {
//                                   "score": 0,
//                                   "name": "nc",
//                                   "englishchoices": [
//                                       "english choice",
//                                       "english choice"
//                                   ],
//                                   "arabicchoices": [
//                                       "dirty",
//                                       "poor condition"
//                                   ]
//                               },
//                               {
//                                   "name": "m",
//                                   "score": 2,
//                                   "arabicchoices": [
//                                       "ملف الحوادث متواجد ولكن غير كاملة"
//                                   ],
//                                   "englishchoices": [
//                                       "available but not completed"
//                                   ]
//                               },
//                               {
//                                   "name": "na"
//                               }
//                           ],
//                           "photourl": [],
//                           "assignto": "6bpx1bOLV07OlHw0UNjy",
//                           "englishansweredchoices": [
//                               "english choice",
//                               "english choice"
//                           ],
//                           "arabicansweredchoices": [
//                               "dirty",
//                               "poor condition"
//                           ],
//                           "answerindex": "",
//                           "duedate": "2024-03-25",
//                           "arabicname": "هل الحوائط و الارضيات نظيفة وفي حالة جيدة ",
//                           "departmentid": "CS2wkskf35SD4E2TRDvb"
//                       },
//                       {
//                           "id": "ec62859f-a675-4225-bdbf-d9703c07e689",
//                           "assignto": "6bpx1bOLV07OlHw0UNjy",
//                           "answerindex": "",
//                           "englishansweredchoices": [
//                               "dirty",
//                               "poor condition"
//                           ],
//                           "score": 0,
//                           "arabicansweredchoices": [
//                               "متسخة",
//                               "في حالة سيئة"
//                           ],
//                           "duedate": "2024-03-25",
//                           "photourl": [],
//                           "answer": true,
//                           "departmentid": "uWUR4P1pSF4BXJvhhozj",
//                           "images": [
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405148415.jpg?alt=media&token=7f07ac88-b09f-4302-a68f-b2dc1ad696ef"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405149247.jpg?alt=media&token=a2120ca0-9cc8-4415-bc74-ffa4bc378858"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405150059.jpg?alt=media&token=b63f87b6-f879-4b50-882a-4da718d5c4ad"
//                               }
//                           ],
//                           "arabicname": "هل الارضيات نظيفة و في حالة جيدة ",
//                           "answers": [
//                               {
//                                   "englishchoices": [
//                                       "clean and in good condition"
//                                   ],
//                                   "arabicchoices": [
//                                       "نظيفة و في حالة جيدة"
//                                   ],
//                                   "score": 5,
//                                   "name": "c"
//                               },
//                               {
//                                   "arabicchoices": [
//                                       "متسخة",
//                                       "في حالة سيئة"
//                                   ],
//                                   "englishchoices": [
//                                       "dirty",
//                                       "poor condition"
//                                   ],
//                                   "score": 0,
//                                   "name": "nc"
//                               },
//                               {
//                                   "arabicchoices": [
//                                       "ملف الحوادث متواجد ولكن غير كاملة"
//                                   ],
//                                   "englishchoices": [
//                                       "available but not completed"
//                                   ],
//                                   "score": 2,
//                                   "name": "m"
//                               },
//                               {
//                                   "name": "na"
//                               }
//                           ],
//                           "englishname": "are floors clean and in good condition "
//                       },
//                       {
//                           "id": "f3468c35-15d7-45b6-835e-1a79e8abdad1",
//                           "arabicname": "هل الاسقف جيدة و في حالة جيدة  ",
//                           "photourl": [],
//                           "score": 0,
//                           "assignto": "6bpx1bOLV07OlHw0UNjy",
//                           "departmentid": "CS2wkskf35SD4E2TRDvb",
//                           "duedate": "2024-03-25",
//                           "answerindex": "",
//                           "answer": true,
//                           "answers": [
//                               {
//                                   "score": 5,
//                                   "englishchoices": [
//                                       "clean and in good condition"
//                                   ],
//                                   "arabicchoices": [
//                                       "نظيفة و في حالة جيدة"
//                                   ],
//                                   "name": "c"
//                               },
//                               {
//                                   "arabicchoices": [
//                                       "متسخة",
//                                       "في حالة سيئة",
//                                       "يوجد تسريب من السقف",
//                                       "قشور من السقف"
//                                   ],
//                                   "name": "nc",
//                                   "score": 0,
//                                   "englishchoices": [
//                                       "dirty",
//                                       "poor condition",
//                                       "evidence of leakage",
//                                       "paint flecks"
//                                   ]
//                               },
//                               {
//                                   "englishchoices": [
//                                       "available but not completed"
//                                   ],
//                                   "name": "m",
//                                   "arabicchoices": [
//                                       "ملف الحوادث متواجد ولكن غير كاملة"
//                                   ],
//                                   "score": 2
//                               },
//                               {
//                                   "name": "na"
//                               }
//                           ],
//                           "arabicansweredchoices": [
//                               "متسخة",
//                               "في حالة سيئة",
//                               "قشور من السقف"
//                           ],
//                           "englishname": "Is ceiling clean and in good condition ",
//                           "englishansweredchoices": [
//                               "dirty",
//                               "poor condition",
//                               "paint flecks"
//                           ],
//                           "images": [
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405150946.jpg?alt=media&token=130c79e3-cc18-4f2b-8198-eefb607f8532"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405151905.jpg?alt=media&token=b1054e19-d5b5-4da2-a041-b8f953ce5289"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405153345.jpg?alt=media&token=34063322-1497-4ac1-ba0e-0826601bcc70"
//                               }
//                           ]
//                       }
//                   ],
//                   "score": 0
//               },
//               {
//                   "questions": [
//                       {
//                           "id": "20c6c9c4-7788-4218-88a2-0e85f6965f68",
//                           "photourl": [],
//                           "score": 5,
//                           "images": [
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405154235.jpg?alt=media&token=8c830f1e-919f-4a39-9a3d-ac1b849fe398"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405154947.jpg?alt=media&token=813e914a-08bb-49b1-b8b9-b394b4c36a5a"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405155912.jpg?alt=media&token=d8a4c6d4-22a0-48aa-bee6-04d1cb6892fa"
//                               }
//                           ],
//                           "arabicansweredchoices": [
//                               "تتم بشكل مناسب وصحيح"
//                           ],
//                           "arabicname": "هل عملية ازالة البقايا تتم بشكل مناسب ",
//                           "answer": true,
//                           "departmentid": "CS2wkskf35SD4E2TRDvb",
//                           "answers": [
//                               {
//                                   "score": 5,
//                                   "arabicchoices": [
//                                       "تتم بشكل مناسب وصحيح"
//                                   ],
//                                   "englishchoices": [
//                                       "proper hand-scraping"
//                                   ],
//                                   "name": "c"
//                               },
//                               {
//                                   "englishchoices": [
//                                       "improper hand scraping",
//                                       "no hand scraping carried out"
//                                   ],
//                                   "score": 0,
//                                   "name": "nc",
//                                   "arabicchoices": [
//                                       "لا تتم بشكل مناسب ",
//                                       "لا تتم اطلاقا"
//                                   ]
//                               },
//                               {
//                                   "score": 2,
//                                   "name": "m",
//                                   "arabicchoices": [
//                                       "ملف الحوادث متواجد ولكن غير كاملة"
//                                   ],
//                                   "englishchoices": [
//                                       "available but not completed"
//                                   ]
//                               },
//                               {
//                                   "name": "na"
//                               }
//                           ],
//                           "answerindex": "",
//                           "englishname": "is hand-scarping process carried out properly ",
//                           "englishansweredchoices": [
//                               "proper hand-scraping"
//                           ]
//                       },
//                       {
//                           "id": "8620c03b-2e4a-4f2c-be96-7036db479e76",
//                           "score": 0,
//                           "answerindex": "",
//                           "answers": [
//                               {
//                                   "englishchoices": [
//                                       "non-abrasive pads used"
//                                   ],
//                                   "name": "c",
//                                   "score": 5,
//                                   "arabicchoices": [
//                                       "تستخدم ادوات مناسبة غير خشنة"
//                                   ]
//                               },
//                               {
//                                   "score": 2,
//                                   "englishchoices": [
//                                       "available but not completed"
//                                   ],
//                                   "name": "m",
//                                   "arabicchoices": [
//                                       "ملف الحوادث متواجد ولكن غير كاملة"
//                                   ]
//                               },
//                               {
//                                   "englishchoices": [
//                                       "scouring pads or other abrasive items used"
//                                   ],
//                                   "score": 0,
//                                   "arabicchoices": [
//                                       "تستخدم ادوات خشنة"
//                                   ],
//                                   "name": "nc"
//                               },
//                               {
//                                   "name": "na"
//                               }
//                           ],
//                           "englishansweredchoices": [
//                               "scouring pads or other abrasive items used"
//                           ],
//                           "assignto": "6bpx1bOLV07OlHw0UNjy",
//                           "departmentid": "uWUR4P1pSF4BXJvhhozj",
//                           "answer": true,
//                           "images": [
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405156653.jpg?alt=media&token=e2f4c268-433e-466e-98cc-1c3fa220f66f"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405157469.jpg?alt=media&token=0aa49238-e4a9-46aa-b49d-2906e2f41b81"
//                               },
//                               {
//                                   "url": "https://firebasestorage.googleapis.com/v0/b/i-monitor-19ba2.appspot.com/o/3_1711405158128.jpg?alt=media&token=bbcff9cb-e407-4141-9478-3db71a694355"
//                               }
//                           ],
//                           "duedate": "2024-03-25",
//                           "arabicansweredchoices": [
//                               "تستخدم ادوات خشنة"
//                           ],
//                           "englishname": "are scouring pads or other abrasive items used for scraping ",
//                           "photourl": [],
//                           "arabicname": "هل يتم استخدام ادوات ازالة البقايا تسبب تجريح او خشنة "
//                       }
//                   ],
//                   "score": 0,
//                   "name": "preparatory process"
//               }
//           ],
//           "id": "mWwFtYlRMTn6SmSCjJVx",
//           "name": "Food Saftey",
//           "url": "file:///storage/emulated/0/Android/data/io.ionic.imonitor/files//Audit/Test Module/underupload/2024-03-2522-17",
//           "iconmd": "md-american-football"
//       },
//       "StartTime": "22:17",
//       "EndDate": "2024-03-25",
//       "branchid": "adrU2MJUQ49F414ljmIF",
//       "StartDate": "2024-03-25",
//       "clientid": "cEoQAhS4iqnRjudMnIbM",
//       "PlaceAudit": "cairo",
//       "EndTime": "00:19:01",
//       "TypeAudit": "Daily",
//       "auditerId":"Bf6bFJMW9o5LYcY14f4h"
//   };
//     this.TestAddauditS(item).subscribe(
//       (response) => {
//         console.log('Audit created successfully:', response);
//       },
//       (error) => {
//         console.error('Error creating audit:', error);
//       })
//   }
  updateUser() {
    const email = 'faten.mohamed@fvtm.bu.edu.eg'; // Email of the user you want to update
    const databaseName = 'renaissance'; // New database name for the user

    this.updateUserservice(email, databaseName).subscribe({
      next: (response) => {
        console.log('User updated successfully:', response);
      },
      error: (error) => {
        console.error('Error updating user:', error);
      },
    });
  }
  // createUserS(email: string, password: string, databaseName: string): Observable<any> {
  //   const url = 'https://createuserwithcustomclaim-tccea3va2a-uc.a.run.app/createUser'; // Replace with your function's URL
  //   const userData = { email, password, databaseName };
  //   return this.http.post(url, userData);
  // }
  // createUser() {
  //   const email = 'admin@imonitortech.com';
  //   const password = 'Aa123456';
  //   const databaseName = '(default)';

  //   this.createUserS(email, password, databaseName)
  //     .subscribe(response => {
  //       console.log('User created successfully:', response);
  //     }, error => {
  //       console.error('Error creating user:', error);
  //     });
  // }

    
  



 


  
}

